import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import HomePage from '@/pages/HomePage';
import PaymentSuccess from '@/pages/PaymentSuccess';
import PaymentCancel from '@/pages/PaymentCancel';
import RateCardPage from '@/pages/RateCardPage';
import PartnerApplyPage from '@/pages/PartnerApplyPage';
import AftercarePage from '@/pages/AftercarePage';
import HowItWorksPage from '@/pages/HowItWorksPage';
import LoginPage from '@/pages/LoginPage';
import SchedulePage from '@/pages/SchedulePage';
import AdminPage from '@/pages/AdminPage';
import DashboardPage from '@/pages/DashboardPage';
import MobileAdminApp from '@/pages/MobileAdminApp';
import { AudienceProvider } from '@/context/AudienceContext';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import HashScroll from '@/components/HashScroll';

function Protected({ children, requireAdmin = false }) {
  const { isAuthed, isAdmin } = useAuth();
  if (!isAuthed) return <Navigate to={`/login?next=${encodeURIComponent(window.location.pathname)}`} replace />;
  if (requireAdmin && !isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AudienceProvider>
        <AuthProvider>
          <BrowserRouter>
            <HashScroll />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/rates" element={<RateCardPage />} />
              <Route path="/partners" element={<PartnerApplyPage />} />
              <Route path="/aftercare" element={<AftercarePage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/book" element={<Navigate to="/schedule" replace />} />
              <Route path="/embed/schedule" element={<SchedulePage embed />} />
              <Route path="/dashboard" element={<Protected><DashboardPage /></Protected>} />
              <Route path="/admin" element={<Protected requireAdmin><AdminPage /></Protected>} />
              <Route path="/m/*" element={<Protected requireAdmin><MobileAdminApp /></Protected>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </AudienceProvider>
      <Toaster theme="dark" position="top-right" richColors closeButton />
    </div>
  );
}
